import { UpdateSite } from '@vetahealth/tuna-can-api'

import { convertEmptyStringToNull, omitUndefined, trimDeep } from '../../lib/normalizers'

export function normalizeSiteValues(values: UpdateSite): UpdateSite {
  // Do not normalize units
  const { defaultUnits, ...rest } = trimDeep(values)
  return { ...convertEmptyStringToNull(omitUndefined(rest)), defaultUnits }
}
